// ======================================================================
// File Name       : DownloadConfigFileList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, Button, Table } from 'react-bootstrap';
import ReduxFormPaging from '../ReduxFormPaging';
import { convertStatusConfigFile } from '../../utils/index';
import { CONFIG_FILE_STATUS } from '../../constants/index';

class DownloadConfigFileList extends React.Component {

  render() {
    const {
      userfrontDownloadResultList,
      recordNum,
      handleSortState,
      invalid,
      refreshData,
      getStartEndData,
      onClickDownloadFile,
      startPosition,
    } = this.props;
    const thead = [
      { title: 'No', sortBy: null, width: 50 },
      { title: 'ファイル名', sortBy: null },
      { title: 'ステータス', sortBy: 1 },
      { title: '開始日時', sortBy: 2 },
      { title: '完了時間', sortBy: 3 },
      { title: '処理結果', sortBy: null, width: 130 },
    ];
    const userfrontDownloadResultData = userfrontDownloadResultList &&
      userfrontDownloadResultList.map((userfrontDownloadResult, index) => {
        let isShowButtonDownload = false;
        if (userfrontDownloadResult.userfrontDownloadResultStatus === CONFIG_FILE_STATUS.PROCESSED ||
          userfrontDownloadResult.userfrontDownloadResultStatus === CONFIG_FILE_STATUS.ERROR) {
          isShowButtonDownload = true;
        }
        return (
          <tr key={index}>
            <td>{startPosition + index + 1}</td>
            <td>{userfrontDownloadResult.userfrontDownloadFileName}</td>
            <td>{convertStatusConfigFile(userfrontDownloadResult.userfrontDownloadResultStatus)}</td>
            <td>{userfrontDownloadResult.userfrontDownloadStartTime}</td>
            <td>{userfrontDownloadResult.userfrontDownloadEndTime}</td>
            <td>{ isShowButtonDownload &&
              <Button
                variant="primary"
                className="btn-96 text-center"
                onClick={() => {
                  onClickDownloadFile(
                    userfrontDownloadResult.resultFileUrl,
                    userfrontDownloadResult.userfrontDownloadFileName,
                  );
                }}
                id={index}
              >
                ダウンロード
              </Button>
            }
            </td>
          </tr>
        );
      });
    return (
      <div>
        <Form.Group>
          <Col sm={12}>
            <Button
              variant="primary"
              className="float-end btn-96"
              onClick={refreshData}
            >
              更新
            </Button>
          </Col>
          <Col sm={6} className="float-start padding-top-35">
            ダウンロード結果一覧
          </Col>
          <Col sm={6}>
            <ReduxFormPaging
              type="paging"
              name="startPosition"
              recordNum={recordNum}
              getStartEndData={getStartEndData}
            />
          </Col>
        </Form.Group>
        <Table striped hover>
          <thead>
            <ReduxFormPaging
              type="tableHead"
              data={thead}
              name="userfrontDownloadSortType"
              invalid={invalid}
              handleSortState={handleSortState}
            />
          </thead>
          <tbody>
              {userfrontDownloadResultData}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default DownloadConfigFileList;
